import React from "react";
import { Grid, Box, Typography } from "@mui/material";

const NotAllow = () => (
  <Box>
      <Grid container direction="row" justifyContent="center">
          <Grid item xs={5}>
              <Typography variant="h5" style={{ textAlign: "center" }}>
                  You are not allowed to this page.
              </Typography>
          </Grid>
      </Grid>
  </Box>
);

export default NotAllow;
